import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GridCellRenderer } from '@softapps/core/grid';
import { Stock } from './stock';

@Component({
  selector: 'soft-stock-column',
  imports: [],
  template: `
    <div class="flex flex-col">
      <span class="soft-overline !mb-0">{{ value()?.lager }}</span>
      <span class="text-sm">{{ value()?.name1 }}</span>
    </div>`,
  styles: `
    :host {
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StockColumnComponent<TRow extends object> extends GridCellRenderer<TRow, Stock>{

}
